export default "__VITE_ASSET__CR6lGH9r__"